const initFileInputButton = () => {
  const updateFileName = function(inputElement) {
    let fileNames = Array.from(inputElement.files).map(function(file) {
      return file.name;
    }).join(' ');
    const inputId = inputElement.id;
    const fileTextElement = document.querySelector('[data-for="' + inputId + '"] > .label-text');
    const labelTitle = document.querySelector('[data-for="' + inputId + '"] > .label-title').innerHTML;
    if (fileTextElement) {
      if (fileNames.length > 23) {
        const filenamelength = fileNames.lastIndexOf(".pdf");
        const name = fileNames.slice(0, filenamelength);
        const filename = name.slice(0, 18);
        fileNames = filename + '[...]' + '.pdf';
      }
      fileTextElement.innerHTML = fileNames || labelTitle;
    } else {
      fileTextElement.innerHTML = labelTitle;
    }
  };

  const inputElements = document.querySelectorAll('.bewerbung-form-container input[type="file"]');
  const inputFileLabels = document.querySelectorAll('.file-upload-label');

  if(inputFileLabels.length>0){
    inputFileLabels.forEach((ele) =>{
      ele.addEventListener('click', function (){
        const forValue = ele.dataset.for;
        document.getElementById(forValue).click();
      });
    });
  }
  if(inputElements.length>0){
    inputElements.forEach(function (inputElement) {
          inputElement.addEventListener('change', function() {
              console.log(inputElement);
            updateFileName(inputElement);
          });
    });

    document.addEventListener( 'wpcf7submit', function( event ) {
      const labels = document.querySelectorAll('.file-upload-label .label-text');
      labels.forEach(function(labelEle){
          const originalTitle = labelEle.nextElementSibling;
          if(originalTitle){
              labelEle.innerHTML = originalTitle.innerHTML;
          }else{
              labelEle.innerHTML = 'Datei hochladen';
          }
      })
    }, false );

  }

  const dropzones = document.querySelectorAll('.dropzone');

  dropzones.forEach(dropzone => {
    dropzone.addEventListener('dragover', function(e) {
      e.preventDefault();
      dropzone.classList.add('hover');
    });

    dropzone.addEventListener('dragleave', function(e) {
      e.preventDefault();
      dropzone.classList.remove('hover');
    });

    dropzone.addEventListener('drop', function(e) {
      e.preventDefault();
      dropzone.classList.remove('hover');

      if (e.dataTransfer.files.length > 1) {
        alert('Bitte legen Sie nur eine Datei ab.');
        return; // Abbruch, wenn mehr als eine Datei abgelegt wurde
      }

      const input = dropzone.querySelector('input[type=file]');

      if (e.dataTransfer.files.length) {
        input.files = e.dataTransfer.files;
        let event = new Event('change', {
          bubbles: true,
          cancelable: true,
        });
        input.dispatchEvent(event);
      }
    });
  });

};
export default initFileInputButton;
